import * as Yup from 'yup'

Yup.setLocale({
  mixed: {
    default: 'El campo es inválido.',
    required: 'El campo es requerido.',
    // eslint-disable-next-line
    oneOf: 'El campo debe ser uno de los siguientes valores: ${values}',
    notOneOf:
      // eslint-disable-next-line
      'El campo no debe ser ninguno de los siguientes valores: ${values}',
    notType: ''
  },
  string: {
    // eslint-disable-next-line
    length: 'El campo debe tener ${length} caracteres.',
    // eslint-disable-next-line
    min: 'El campo debe tener ${min} caracteres como mínimo.',
    // eslint-disable-next-line
    max: 'El campo debe tener ${max} caracteres como máximo.',
    matches: 'El campo no cumple con el formato establecido.',
    email: 'El campo debe ser un email válido.',
    url: 'El campo debe ser un URL válido.',
    trim: 'El campo no debe tener espacios extras.',
    lowercase: 'El campo debe estar en minúscula.',
    uppercase: 'El campo debe estar en mayúscula.'
  },
  number: {
    // eslint-disable-next-line
    min: 'El campo debe ser mayor o igual a ${min}',
    // eslint-disable-next-line
    max: 'El campo debe ser menor o igual a ${max}.',
    // eslint-disable-next-line
    lessThan: 'El campo debe ser menor a ${less}.',
    // eslint-disable-next-line
    moreThan: 'El campo debe ser mayot a ${more}.',
    // eslint-disable-next-line
    notEqual: 'El campo no debe ser igual a ${notEqual}.',
    positive: 'El campo debe ser de valor positivo,',
    negative: 'El campo debe ser de valor negativo.',
    integer: 'El campo debe ser numérico entero.'
  },
  array: {
    // eslint-disable-next-line
    min: 'El campo debe tener como minimo ${min} items',
    // eslint-disable-next-line
    max: 'El campo debe tener como máximo ${max} items'
  }
})

export default Yup
